import { AnimatePresence, motion } from "framer-motion";
import { Pencil } from "lucide-react";
import { useSelector } from "react-redux";
import imageDefault from "../../../assets/clientIcon.png"

export default function ClienteModal({ setIsModalOpen, isModalOpen, handleEditToView }) {
  const { client } = useSelector((state) => state.clientes);

  return (
    <AnimatePresence>
      {isModalOpen && (
        <motion.div
          key="modal-background"
          onClick={() => setIsModalOpen(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}>
          <motion.div
            key="modal-content"
            className="bg-white p-8 rounded-xl shadow-2xl max-w-2xl w-full mx-4 relative overflow-hidden"
            initial={{ y: -50, opacity: 0, scale: 0.95 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: -50, opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.3, ease: "easeOut", delay: 0.1 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="absolute top-2 font-poppina right-3 gap-3 flex">
              <button className="cursor-pointer hover:bg-blue-100 p-2 px-[10px] rounded-full  z-50" onClick={() => handleEditToView()} >
                <Pencil className="w-4 h-4  sm:w-5 sm:h-5 text-blue-600 "/>
              </button>
            <button
                onClick={() => setIsModalOpen(false)}
                className=" p-2 rounded-full z-50 hover:bg-gray-200 transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-gray-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="absolute inset-0 bg-background"></div>

            <div className="relative space-y-6">
              <div className="text-center">
                <h1 className="text-3xl font-bold text-text">
                  Información del Cliente
                </h1>
                <p className="text-sm text-subtitle mt-1">
                  Detalles completos del perfil
                </p>
              </div>

              <div className="flex flex-col md:flex-row items-center md:items-start space-y-6 md:space-y-0 md:space-x-8">
                <div className="flex-shrink-0 relative sm:mt-5 ">
                  <img
                    src={client?.profileImage ? client.profileImage : imageDefault }
                    alt="clientImage"
                    className="w-36 h-36 rounded-2xl object-cover border-4 border-white shadow-lg"
                  />
                  <div className="absolute inset-0 rounded-2xl border-2 border-white/50"></div>
                </div>

                <div className="text-left space-y-4 flex-1">
                  <div>
                    <p className="text-lg font-semibold text-text">
                      Nombre del cliente
                    </p>
                    <p className="text-xl text-subtitle font-medium">
                      {client?.name}
                    </p>
                  </div>
                  <div>
                    <p className="text-lg font-semibold text-text">Email</p>
                    <p className="text-xl text-subtitle font-medium">
                      {client?.email}
                    </p>
                  </div>
                  <div>
                    <p className="text-lg font-semibold text-text">
                      Teléfono
                    </p>
                    <p className="text-xl text-subtitle font-medium">
                      {client?.phone}
                    </p>
                  </div>
                  <div>
                    <p className="text-lg font-semibold text-text">
                      Podcasts
                    </p>
                    <p className="text-xl text-subtitle font-medium">
                      {client?.totalPodcasts} totales • {client?.activePlans}{" "}
                      activos
                    </p>
                  </div>
                </div>
              </div>

              
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
